<template>
  <footer v-if="!nocard" class="main-footer base-footer">
    <div class="item user">
      <a
        class="name-card"
        :href="data.nameCard"
        data-stat-id="name"
        :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
      >
        <div class="head">
          <img
            v-if="data.photo"
            :src="`${data.photo}?x-oss-process=image/resize,m_mfit,h_80,w_80`"
            :alt="data.name"
          >
          <p v-else />
          <div v-if="isApp" class="see-btn after-bdr">
            <span>查看名片</span>
          </div>
        </div>
        <div
          class="info"
          :class="{ member: data.memberLevelName || data.offlineBroker }"
        >
          <p class="name">
            <span>{{ data.name }}</span>
            <i
              v-if="data.memberLevelMedal && !data.offlineBroker"
              class="icon-member"
            >
              <img :src="data.memberLevelMedal" :alt="data.memberLevelName">
            </i>
          </p>
          <p v-if="data.offlineBroker">{{ ['BXS'].includes(APP_CHANNEL) ? '保险师' : '' }}专员</p>
          <p v-else-if="data.memberLevelName">{{ data.memberLevelName }}</p>
        </div>
      </a>
    </div>

    <div v-if="isApp" class="item chart">
      <a href="javascript:;" data-stat-id="SCTP" @click="handleChart">
        <span class="inner">生成图片</span>
      </a>
    </div>
    <div v-else class="item phone line">
      <a
        :href="'tel:' + data.telephone"
        data-stat-id="phone"
        :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
      >
        <i class="iconfont icon-phone_line" /><span>联系我</span>
      </a>
    </div>

    <div v-if="isApp" class="item edit">
      <a data-stat-id="share_bottom" @click="handleShare">
        <span class="inner">转发计划书</span>
      </a>
    </div>
    <div v-else class="item see">
      <a
        :href="data.nameCard"
        data-stat-id="name"
        :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
      ><i class="iconfont icon-business_card" /><span>查看名片</span></a>
    </div>
  </footer>
</template>

<script>
import { isApp, APP_CHANNEL } from 'common/utils/variables'
import { getUrlParam, getUrlByAddingParam } from 'common/js/common'

const EVENT_CLICK = 'click'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    inMiniGroup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isApp,
      APP_CHANNEL,
      nocard: false, //&nocard=1
    }
  },
  computed: {
    mini() {
      const { inMiniGroup } = this
      const suptShareMini =
        window.appBridge &&
        appBridge.checkAppFeature('GOTO_WECHAT_MINI_PROGRAM')
      return isApp && inMiniGroup && suptShareMini
    },
  },
  watch: {},
  created() {
    const nocard = getUrlParam('nocard')
    nocard == 1 && (this.nocard = true)
    const uuid = getUrlParam('uuid')
    const theme = getUrlParam('theme')
    const sourceFrom = JSON.stringify({ uuid, theme })
    this.data.nameCard = getUrlByAddingParam(
      {
        sourceFrom,
      },
      this.data.nameCard
    )
  },
  methods: {
    handleShare(e) {
      this.$emit(EVENT_CLICK, e)
    },
    handleChart(e) {
      this.$emit('jump', e)
    },
  },
}
</script>

<style lang="postcss" scoped>
@import 'variable.css';

.main-footer {
  z-index: 100;
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  width: 100%;
  background-color: #f8f8f8;
  text-align: center;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  .item {
    float: left;
    position: relative;
    background-color: #f8f8f8;
    a {
      display: block;
      height: 100%;
      line-height: 60px;
      color: var(--primary-color-text);
    }
  }
  .after-bd-r:after {
    height: 40%;
    bottom: 30%;
    background-color: rgba(51, 51, 51, 0.4);
  }
  .user {
    width: 38%;
  }
  .phone,
  .chart,
  .minipg {
    width: 33%;
  }
  .see,
  .edit {
    width: 29%;
  }
  .name-card {
    .info {
      padding-left: 50%;
      font-size: 15px;
      text-align: left;
      p {
        font-size: 16px;
        font-weight: 400;
        @apply --text-ellipsis;
      }
    }
    .head {
      position: absolute;
      left: 10%;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      > img {
        display: block;
        width: 100%;
        vertical-align: middle;
        border-radius: 100%;
      }
      > p {
        width: 40px;
        height: 40px;
        background-color: #e5e5e5;
        border-radius: 100%;
      }
    }
    .see-btn {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, -50%);
      width: 46px;
      height: 14px;
      line-height: 1;
      font-size: 12px;
      background-color: #e5e5e5;
      span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: scale(0.83) translate(-50%, -50%);
        transform-origin: top left;
        white-space: nowrap;
        width: 100%;
      }
    }
  }
  .icon-member {
    z-index: 1;
    position: absolute;
    display: inline-block;
    overflow: hidden;
    width: 15px;
    height: 15px;
    margin-left: 3px;
    img {
      width: 100%;
    }
  }
  .member {
    padding-top: 13px;
    line-height: 1.2;
    > p {
      @apply --text-ellipsis;
    }
    .name {
      padding-right: 21px;
      span {
        display: inline-block;
        max-width: 100%;
        @apply --text-ellipsis;
      }
    }
    p:last-child {
      margin-top: 3px;
      font-size: 12px;
      color: #999;
      transform: scale(0.83);
      transform-origin: left top;
    }
  }
  .phone,
  .chart,
  .see {
    .iconfont {
      margin-right: 6px;
      font-size: 18px;
      line-height: 1;
      vertical-align: middle;
    }
    span {
      font-size: 14px;
      vertical-align: middle;
      line-height: 1;
    }
  }
  .line {
    &:before,
    &:after {
      @apply --bd-w;
      background-color: var(--primary-color-border);
      height: 58%;
      top: 21%;
    }
    &:before {
      left: 6%;
    }
    &:after {
      right: 6%;
    }
  }
  .phone,
  .chart,
  .edit {
    span {
      display: inline-block;
      padding: 9px 12px;
      font-size: 13px;
      line-height: 1.3;
      border-radius: 2px;
    }
  }
  .chart {
    text-align: right;
    span {
      border-radius: 6px;
      background-color: #fff;
      border: 1px solid #e5e5e5;
    }
  }
  .tr {
    text-align: right;
  }
  .minipg {
    span {
      display: inline-block;
      padding: 9px 12px;
      font-size: 13px;
      line-height: 1.3;
      border-radius: 2px;
      background-color: #fff;
    }
  }
}

@media screen and (device-width <= 320px) {
  .main-footer {
    .name-card {
      .head {
        left: 4%;
      }
      .info {
        p {
          font-size: 13px;
        }
      }
    }
    .chart,
    .see,
    .minipg,
    .edit {
      span {
        font-size: 12px;
      }
    }
    .edit {
      span {
        padding: 7px 10px;
      }
    }
    .icon-member {
      margin-left: 0;
    }
    .minipg {
      span {
        line-height: 1.4;
      }
    }
  }
}
</style>
